import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../../../html/checkbox'
import { Element } from '../../../../../html/element'
import { SCORE_MODE_ID } from '../../../../constant'
import {
  changeCreditScore,
  changePerformanceScore,
  selectScore,
} from '../../../../store/sliceScoreLevel'
import { TYPE_SCORE_VAlUE } from '../../../constant'
import classes from '../scoreLevel.module.scss'

export const TranscriptItem = ({ item, typePeriod, typePeriodTime }) => {
  const dispatch = useDispatch()

  const checked = useSelector(
    selectScore([typePeriod, typePeriodTime, 'fiinGate', item.scoreRangeId]),
  )

  const onCheck = (value) => {
    if (typePeriod === TYPE_SCORE_VAlUE.CREDIT_SCORE) {
      dispatch(
        changeCreditScore({
          path: [typePeriodTime, 'fiinGate', value.scoreRangeId],
          data: !checked,
        }),
      )
    }
    if (typePeriod === TYPE_SCORE_VAlUE.PERFORMANCE_SCORE) {
      dispatch(
        changePerformanceScore({
          path: [typePeriodTime, 'fiinGate', value.scoreRangeId],
          data: !checked,
        }),
      )
    }
  }

  return (
    <>
      <Element
        style={{
          borderBottomColor: '#D5D5D5',
        }}
        className={['dFlex', classes.item].join(' ')}
      >
        <Checkbox
          title={
            item.scoreRange_Min
              ? `${item.scoreRangeName} (${item.scoreRange_Min}-${item.scoreRange_Max})`
              : Number(item.scoreRange_Min) === 0 &&
                item.modelId === SCORE_MODE_ID.CORPORATE_RISK
              ? `${item.scoreRangeName} (0)`
              : `${item.scoreRangeName}`
          }
          isCheckOnClickText
          onChange={() => onCheck(item)}
          checked={checked}
        />
      </Element>
    </>
  )
}
